let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8qy0v")).then(() => parcelRequire('8yzun'));